﻿import { createApi } from "@reduxjs/toolkit/query/react";
import { fetchBaseQueryWrapper } from "./helpers";

export const approvalWorkflowApi = createApi({
  reducerPath: "approvalWorkflowApi",
  baseQuery: fetchBaseQueryWrapper({
    path: "approvalWorkflows",
  }),
  endpoints: (build) => ({
    getApprovalWorkflows: build.query({
      query: () => "",
      transformResponse: ({ data }) => data,
    }),
    getApprovalWorkflow: build.query({
      query: (id) => id,
      transformResponse: ({ data }) => data,
    }),
    getApprovalWorkflowIncludingDeleted: build.query({
      query: (id) => `${id}/deleted`,
      transformResponse: ({ data }) => data,
    }),
    saveApprovalWorkflow: build.mutation({
      query: (approvalWorkflow) => ({
        method: "PUT",
        body: approvalWorkflow,
      }),
    }),
    deleteApprovalWorkflow: build.mutation({
      query: ({ id }) => ({
        url: id,
        method: "DELETE",
      }),
    }),
    deleteApprover: build.mutation({
      query: ({ approvalWorkflowId, approverId }) => ({
        url: `${approvalWorkflowId}/approver/${approverId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetApprovalWorkflowsQuery,
  useGetApprovalWorkflowQuery,
  useGetApprovalWorkflowIncludingDeletedQuery,
  useSaveApprovalWorkflowMutation,
  useDeleteApprovalWorkflowMutation,
  useDeleteApproverMutation,
} = approvalWorkflowApi;
